import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { UserProfileService } from '@ui-app/services/user-profile.service';
import { RoutesConfig } from '@employee-configs/routes.config';
import { UserRoleEnum } from '@shared-models/common.enums';
import { EREQUEST_ACTION } from '@employee-pages/badge-requests/request-edit/models';


@Injectable({
    providedIn: 'root'
})
export class RoleGuard implements CanActivate {

    constructor(
        private router: Router,
        private userProfileService: UserProfileService
    ) {
    }


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean | Promise<boolean> {
        const requiredRolesIds: Array<UserRoleEnum> = route.data.rolesIds || null;

        const onbehalfRoles = [
            UserRoleEnum.CsbaUS,
            UserRoleEnum.CsbaUSI,
            UserRoleEnum.SecurityUS,
            UserRoleEnum.SecurityUSI]
        // Allow PPMD badge requests without role restriction
        const isPPMD = route.queryParamMap.get('isPPMD') === 'true';
        const isOnBehalf = route.queryParamMap.get('isOnBehalf') === 'true';
        if (isPPMD) {
            return true;
        }
        const user = this.userProfileService.user;
        if(isOnBehalf && onbehalfRoles.includes(user.userRoleId)){
            return true;
        }

        if (this.userProfileService.isUserSessionReady(requiredRolesIds) || state.url.includes(EREQUEST_ACTION.copy) || state.url.includes(EREQUEST_ACTION.edit)) {
            return true;
        } else {            
            const employeeArr = [
                UserRoleEnum.Employee,
                // FullTimeEmployee && ContractorsOrInterns roles match Employee
                UserRoleEnum.FTE,
                UserRoleEnum.CLE,
                UserRoleEnum.CTH,
                UserRoleEnum.EchoPartner,
                UserRoleEnum.EmployeeUS,
                UserRoleEnum.EmployeeUSI,
                UserRoleEnum.FacilitatorUSI,
            ];

            if (employeeArr.includes(user.userRoleId) && !state.url.includes(RoutesConfig.pages.manualActions)) {
                return this.router.navigate(['/profile', this.userProfileService.user.userId]);
            } else {
                return this.router.navigate(['access-denied']);
            }
        }

    }

}
